export default theme => ({
  root: {
    marginBottom: theme.spacing(9)
  },
  categoryContainer: {
    margin: '20px 0',
    position: 'relative',
    '& > div.category-scroll-padding': {
      position: 'absolute',
      top: -105
    }
  },
  nextBtnContainer: {
    display: 'none',
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 75,

    [theme.breakpoints.down('xs')]: {
      display: 'flex'
    }
  },
  nextBtn: {
    margin: 'auto',
    maxWidth: 280
  },
  topCatalogHeader: {
    fontFamily: 'Gilroy',
    fontSize: 36,
    fontWeight: 600,
    color: '#131415',
    marginBottom: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 34
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 27,
      marginBottom: 10
    }
  },
  subHeader: {
    fontFamily: 'Gilroy',
    fontSize: 14,
    lineHeight: 1.43,
    fontWeight: 400,
    color: '#4A4F54',
    [theme.breakpoints.down('xs')]: {
      fontSize: 12
    }
  }
});
